import { Component, Prop, Vue } from 'vue-property-decorator';

import '../../../../../../../node_modules/tiny-slider/src/tiny-slider.scss';
import { TinySliderInstance, TinySliderSettings, tns } from 'tiny-slider';
import { delay } from '../../utils/async';

// @ts-ignore

const template = `
<div class="slider3" :class="mainClass">
  <div class="slider3__nav2">
    <div class="slider3__prev" @click="prevSlide">
      <i class="arr-left arr-left--blue2"></i>
    </div>
    <div class="slider3__next" @click="nextSlide">
      <i class="arr-right arr-right--blue2"></i>
    </div>
  </div>
  <div class="slider3__tns" ref='slider-container'>
    <div class="slider3__item" v-for='(key, k) in slotKeys'>
      <slot :name="key"></slot>
    </div>
  </div>
  <div class="slider3__nav" v-if="sliderPages > 1">
    <div class="slider3__prev" @click="prevSlide">
      <i class="arr-left arr-left--blue2"></i>
    </div>
    <div class="slider3__info">{{ sliderIndex }} / {{ sliderPages }}</div>
    <div class="slider3__next" @click="nextSlide">
      <i class="arr-right arr-right--blue2"></i>
    </div>
  </div>
</div>`;

@Component({
  template: template
})
export default class Slider3 extends Vue {
  @Prop({default: 'slider3--default'}) mainClass!: string;
  @Prop({
    default: () => {
      return {};
    }
  }) sliderOpts!: TinySliderSettings;
  sliderPages = 0;
  sliderIndex = 0;
  private slider?: TinySliderInstance = undefined;

  get slotKeys() {
    return Object.keys(this.$slots)
  }

  async mounted() {
    this.slider = tns(
      Object.assign(
        {
          items: 1,
          autoWidth: false,
          controls: false,
          nav: false,
          loop: false,
          mouseDrag: true,
          swipeAngle: false,
          gutter: 0,
          container: this.$refs['slider-container'],
          speed: 400,
          responsive: {
            768: {
              items: 3,
              gutter: 1,
            },
          }
        },
        this.sliderOpts
      )
    );

    await delay(500);
    // window.dispatchEvent(new Event('resize'));

    this.setSliderInfo();

    this.slider.events.on('newBreakpointEnd', () => {
      this.setSliderInfo();
    });

    this.slider.events.on('indexChanged', () => {
      this.setSliderInfo();
    });
  }

  nextSlide() {
    this.slider?.goTo('next');
  }

  prevSlide() {
    this.slider?.goTo('prev');
  }

  setSliderInfo() {
    const info = this.slider!.getInfo() as any;

    this.sliderPages = info.items == 1 ? 3 : 1;
    this.sliderIndex = info.displayIndex || (info.index + 1);
  }
}
